// import 'animate.css';
import './tailwind.css';
import './sib-styles.css';
import axios from 'axios'
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus'
import masonry from 'alpinejs-masonry';
import globals from './globals';
import { register } from 'swiper/element/bundle';
import 'flowbite';
register();
window.environment = process.env.NODE_ENV;
if (environment === 'development') {
  window.Alpine = Alpine;
} else {
  window.AlpineX = Alpine;
}

if('refresh_token' in localStorage){
  localStorage.removeItem('refresh_token');
}
if('access_token' in localStorage){
  localStorage.removeItem('access_token');
}
Alpine.store('site', globals());
Alpine.plugin(collapse);
Alpine.plugin(masonry);
Alpine.plugin(focus);
Alpine.start();

/** CHECK BROWSER DEFAULT LANGUAGE */
/**
const userLang = navigator.language || navigator.userLanguage; 
console.log(userLang)
let mainLang = userLang.split('-')[0];
mainLang = mainLang == 'pt' ? 'pt-PT' : mainLang
// if not on default locale
if(mainLang != 'de'){
  // if locale is supported
  if(Shopify.supportedLocales && Shopify.supportedLocales.includes(mainLang)){
    
    // if language has NOT been set from the selector
    if(localStorage.getItem('selected_locale') == null){
      localStorage.setItem('selected_locale', mainLang);
      const input = document.querySelector('input[name="language_code"], input[name="country_code"]');
      const form = document.querySelector('.app-localization-form');
      input.value = mainLang
      form.submit();
      // window.location.href = 
    }
    // set locale
  }
  // if not supported
  else{
    // set to English
    mainLang = 'en'
    if(localStorage.getItem('selected_locale') == null){
      localStorage.setItem('selected_locale', mainLang);
      const input = document.querySelector('input[name="language_code"], input[name="country_code"]');
      const form = document.querySelector('.app-localization-form');
      input.value = mainLang
      form.submit();
      // window.location.href = 
    }
  }
}
**/